export type EventProperties = Record<string, unknown>;
